exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr{border:.5px solid rgba(255,255,255,.25);margin:.5em}", ""]);

// exports
